import { ArrowRight, BarChart3, CalendarDays, Globe, Link2, ShieldCheck, Users } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { useDialogs } from "@/lib/dialogs";
import { LaptopMock, PhoneMock } from "@/components/portal/HeroMocks";

const TRUST = [[ShieldCheck, "Trusted", "Network"], [Users, "Planner", "Growth"], [CalendarDays, "Event", "360"], [Globe, "Indian", "Languages"], [BarChart3, "India to", "UAE"]];

export const Hero = () => {
  const { t } = useI18n();
  const open = useDialogs();
  return (
    <section className="hero" data-testid="hero-section">
      <div className="copy">
        <div className="tag goldtag" data-testid="hero-tag">IN · {t("hero_tag")}</div>
        <h1 data-testid="hero-headline">{t("hero_h1_a")} <em>{t("hero_h1_em")}</em> {t("hero_h1_b")}</h1>
        <p data-testid="hero-description">{t("hero_desc")}</p>
        <div className="hero-buttons">
          <button className="btn gold" onClick={() => open("onboard")} data-testid="hero-start-pilot-button">{t("start_pilot")} <ArrowRight className="ic" /></button>
          <button className="btn clear" onClick={() => open("launcher")} data-testid="hero-open-workspace-button">{t("open_workspace")} <Link2 className="ic" /></button>
        </div>
        <div className="trust-row">
          {TRUST.map(([Icon, a, b]) => (
            <div key={a} className="trust"><div className="circle"><Icon className="ic lg" /></div><span>{a}<br />{b}</span></div>
          ))}
        </div>
      </div>
      <div className="photo"><img src="/assets/img0.jpg" alt="Professionals organizing a premium event" /></div>
      <div className="screens"><LaptopMock /><PhoneMock /></div>
    </section>
  );
};

export const IntroStrip = () => {
  const { t } = useI18n();
  const open = useDialogs();
  return (
    <div className="intro-strip" data-testid="intro-strip">
      <div className="left"><strong>One portal. One existing enterprise Event Management platform.</strong><span>No parallel CRM, ERP or procurement systems.</span></div>
      <button className="btn outline small" onClick={() => open("launcher")} data-testid="intro-launcher-button"><Link2 className="ic" /> {t("launcher")}</button>
    </div>
  );
};
